// @flow

import React from 'react';
import { Wrapper } from '@riseart/layout';
import { FilterBuilder, FilterContainerLoader } from '@riseart/filter';
import { FilterSection } from 'shared_components/common/filters/container/Section';
import { CollectionArtFilterModel } from 'shared_models/filters/CollectionArt';
import type { FilterContainerProps } from 'shared_hocs/filters/Container';

/**
 * CollectionFiltersArt
 *
 * @param {FilterContainerProps} props
 */
export const CollectionFiltersArt = ({ isLoading, ...restProps }: FilterContainerProps) => {
  return (
    <FilterContainerLoader component={FilterSection} isLoading={isLoading}>
      <Wrapper
        sizes={{
          xs: 'wide',
          sm: 'wide',
          md: 'wide',
          lg: 'narrow',
          xl: 'narrow',
        }}
      >
        <FilterBuilder {...restProps} config={CollectionArtFilterModel} />
      </Wrapper>
    </FilterContainerLoader>
  );
};
